import React from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import LoginModal from './LoginModal';
import { styled } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { getLogin } from './account.actions';
import { Alert } from '@material-ui/lab';
import { Form, FormGroup } from 'reactstrap';
import KeyboardEventHandler from 'react-keyboard-event-handler';
const MyButton = styled(Button)({
  background: 'white',
  border: 0,
  borderRadius: 3,
  boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
  color: '#00BBBB',
  textTransform: 'none',
  height: 48,
  padding: '0 30px',
});

const MyTextField = styled(TextField)({
  background: 'white',
  border: 0,
  borderRadius: 3,
  boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
  textTransform: 'none',
  height: 48,
  padding: '10px',
});

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: 'white',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

function Login(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [password, setPassword] = React.useState("");
  const [showPassword, setShowPassword] = React.useState(false);
  const handleTogglePassword = () => setShowPassword(showPassword => !showPassword);
  window.localStorage.clear()
  const handleLogin = () => {
    var username = document.getElementById('email').value;
    var password = document.getElementById('password').value;
    props.callLogin(username, password);
  }

  return (
    <>
      {open && <LoginModal open={open} setOpen={setOpen} />}

      <div style={{
        backgroundImage: `url(${'/MainBG7.jpg'})`,
        position: 'fixed',
        top: '0',
        width: '100vw',
        height: '100%',
        backgroundSize: 'cover',
        backgroundRepeat: "no-repeat",
      }}>
        <Container component="main" maxWidth="xs" >

          <CssBaseline />
          <div className={classes.paper}>
            <div><object data="tcd old logo.svg" height='140px' width='250px' style={{marginTop: '-30px', marginBottom: '40px' }}> </object></div>
            <h2 style={{ color: 'rgb(114 160 190)' }}>LOGIN</h2>
              <form className={classes.form} noValidate>
              {props.wrongCredentials && <Alert variant="filled" severity="error">
                Invalid Credentials Try Again</Alert>}
              <MyTextField
                placeholder='Email address'
                className={classes.margin}
                id="email"
                fullWidth
                required
                margin='normal'
                InputProps={{
                  disableUnderline: true,
                  startAdornment: <img src="email.svg" alt="Email icon" style={{ paddingRight: '10px' }} />,
                  style: {
                    color: '#00BBBB'
                  }
                }}
              />




              <KeyboardEventHandler
                handleKeys={['Enter']}
                onKeyEvent={(key, e) => handleLogin()} >

                <MyTextField 
                  placeholder='Password'
                  marginLeft='30px'
                  className={classes.margin}
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  fullWidth
                  required
                  margin='normal'
                  InputProps={{
                    onBlur: (event) => {
                      const value = event.target.value;
                      setPassword(value)
                    },

                    disableUnderline: true,
                    startAdornment: <img src="password.svg" alt="Password icon" style={{ paddingRight: '17px' }} />,
                    endAdornment: (
                      <InputAdornment position="end">

                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleTogglePassword}
                        >
                          {showPassword ? <VisibilityIcon style={{ color: '#00BBBB' }} /> : <VisibilityOffIcon style={{ color: '#00BBBB' }} />}
                        </IconButton>

                      </InputAdornment>

                    ),
                    autoComplete: "off",
                    style: {
                      color: '#00BBBB',
                    }
                  }} />

              </KeyboardEventHandler>

              <MyButton
                fullWidth
                variant="contained"
                onClick={handleLogin}
                className={classes.submit}
              >
                Log In
              </MyButton>

            </form>
          </div>
        </Container>
      </div>
    </>
  );
}

const mapDispatchToProps = dispatch => {
  return {
    // dispatching plain actions
    callLogin: (username, password) => dispatch(getLogin(username, password)),
  }
}

const mapStateToProps = (state, ownProps, number) => ({
  wrongCredentials: state.userAccountReducer.wrongCredentials
})

export default connect(mapStateToProps, mapDispatchToProps)(Login);
